import moment from 'moment-timezone';
import {useEffect, useState} from 'react';
import {Modal} from 'react-bootstrap';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {calendar} from '../../assets/imageDir';
import {BOOKING_TYPES} from '../../common/config';
import {
  addClassBookingDetails,
  authCompanyData,
  clearCompanyData,
  redirectPublicUser,
} from '../../redux/actions/index';
import {BASE_URL_WEB, IMAGE_URL} from '../../utility/constants';
import {
  AxiosHelperPortal,
  calcClassRemainingSpots,
  openInNewTab,
  showToast,
} from '../../utility/helperFunctions';
import {ToastNotification} from '../index';
import useQuery from '../../hooks/useQuery';
import {classCancellationError, clientCanCancelCamp} from '../../utility/cancellationPolicy';
import {
  canProgressFromMultiDayCampLink,
  getMultiDayCampAvailability,
  linkedCampOccurrenceIsUnavailable,
} from '../../utility/campBooking';
import WaitlistActions from '../WaitlistActions';
import './styles.css';

const EventsClassModal = ({show, onHide, details}) => {
  console.log('class details ==> ', details);
  const branchIdUrlQuery = useQuery().get('branchId');
  const history = useHistory();
  const authDetails = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const timezone =
    authDetails?.companyData?.branch?.timezone ||
    authDetails?.companyData?.branches?.items?.find(branch => branch?.id === branchIdUrlQuery)
      ?.timezone;
  const isMultiDayCamp = Boolean(details?.isCamp && details?.repeat_id);
  const multiDayCampAvailability = getMultiDayCampAvailability(details);
  const linkedOccurrenceUnavailable = linkedCampOccurrenceIsUnavailable(details);

  // Safari's browser bars can make the visible viewport shorter than 100vh.
  // Keep the action footer inside that visible area while the description scrolls.
  const [viewportHeight, setViewportHeight] = useState(null);
  useEffect(() => {
    if (!show) return;
    const viewport = window.visualViewport;
    const updateHeight = () =>
      setViewportHeight(Math.min(window.innerHeight, viewport?.height || window.innerHeight));
    updateHeight();
    viewport?.addEventListener('resize', updateHeight);
    window.addEventListener('resize', updateHeight);
    return () => {
      viewport?.removeEventListener('resize', updateHeight);
      window.removeEventListener('resize', updateHeight);
    };
  }, [show]);

  const [cancelClassLoading, setCancelClassLoading] = useState(false);

  const [isClassFull, setIsClassFull] = useState(false);

  // NEW: controls whether the "confirm cancellation" modal is shown
  const [showCancelConfirmModal, setShowCancelConfirmModal] = useState(false);

  useEffect(() => {
    if (isMultiDayCamp && multiDayCampAvailability) {
      setIsClassFull(multiDayCampAvailability.days.length === 0);
    } else if (isMultiDayCamp) {
      setIsClassFull(false);
    } else if (calcClassRemainingSpots(details) === 'Class Full') {
      setIsClassFull(true);
    } else {
      setIsClassFull(false);
    }
  }, [details, authDetails?.companyData, isMultiDayCamp, multiDayCampAvailability]);

  useEffect(() => {
    const member_services = authDetails?.companyData?.member_service;
    let new_member_service = null;
    if (member_services?.length != null && member_services.length > 0) {
      new_member_service = member_services.filter(
        e => e.typename === 'membership_plan_subscribers'
      );
    }
    if (new_member_service === null || details?.serviceId == null) {
      getRemainingSpots();
    }
  }, [details, authDetails?.companyData]);

  // Fetch remaining spots for multi-class packs or single service credits
  const getRemainingSpots = () => {
    let remaining = 0;
    const member_services = authDetails?.companyData?.member_service;
    const multi_class_pack = authDetails?.companyData?.services?.multi_class_pack;

    if (member_services?.length != null && member_services.length > 0) {
      let new_member_service = member_services.filter(
        e =>
          (e.typename === 'member_multi_class_pack' &&
            e?.ptRemaining != null &&
            e.ptRemaining > 0 &&
            multi_class_pack.length != null &&
            multi_class_pack.length > 0 &&
            multi_class_pack.find(
              m =>
                (m.uuid === e.multiClassPackId && m?.isAllClassPack === true) ||
                (m?.selectedClasses?.length != null &&
                  m?.selectedClasses?.length > 0 &&
                  m?.selectedClasses.includes(details?.serviceId))
            )) ||
          (e.typename === 'member_service' &&
            e?.ptRemaining != null &&
            e.ptRemaining > 0 &&
            e.serviceId === details?.serviceId)
      );

      if (new_member_service?.length != null && new_member_service?.length > 0) {
        remaining = new_member_service.reduce((total, val) => {
          if (val?.ptRemaining != null) {
            return total + val.ptRemaining;
          }
          return total;
        }, 0);
      }
    }

    return remaining;
  };

  // ================================================
  // 1) Extracted cancellation logic to a new function
  // ================================================
  const cancelClass = async () => {
    setCancelClassLoading(true);
    if (!clientCanCancelCamp(details)) {
      setCancelClassLoading(false);
      showToast.error('Please contact the coach to cancel this registration.');
      return;
    }
    const cancellationError = classCancellationError({
      companyData: authDetails?.companyData,
      booking: details,
    });
    if (cancellationError) {
      setCancelClassLoading(false);
      showToast.error(cancellationError);
      return;
    }
    const memberId = authDetails?.companyData?.member?.id;
    const payload = {
      cancelAllAppointments: null,
      cancelType: 'session_credit',
      cancelledReason: 'Cancelled by client',
      groupClassId: details?.uuid,
      partialRefundAmount: null,
      paymentMethod: 'pay_now_cash',
      refundType: null,
      uuid: details?.bookingId,
      memberId: memberId,
      orderId: details?.orderId,
      isGroupClass: 'yes',
      from: 'client_portal',
      fmIds: ['_parent'],
      isFromClient: true,
      start: details?.start,
    };
    console.log('payload', payload);
    const url = `${BASE_URL_WEB}appointment-cancel?`;
    console.log('url', url, payload);

    try {
      const response = await AxiosHelperPortal(url, 'post', payload);
      console.log('response', response);
      setCancelClassLoading(false);
      if (response?.data?.cancellationError === true) {
        showToast.error(response?.data?.message);
      } else {
        dispatch(authCompanyData());
        history.push({
          pathname: '/class-booking',
        });
        showToast.success('Your class is cancelled successfully.');
      }
    } catch (error) {
      console.log('err', error);
      setCancelClassLoading(false);
      showToast.error(error.response?.data?.message);
    }
  };

  // ================================================
  // 2) Modified onBook to show confirmation modal
  // ================================================
  const onBook = () => {
    // If user is about to cancel
    if (
      details?.isBooked &&
      details.typename !== BOOKING_TYPES.APPOINTMENT &&
      details?.familyMembers?.length === 0 &&
      clientCanCancelCamp(details)
    ) {
      // Show "Are you sure you want to cancel?" modal
      setShowCancelConfirmModal(true);
    } else {
      // Otherwise, continue booking flow
      dispatch(
        addClassBookingDetails({
          ...details,
          isClassFull,
        })
      );
      history.push({
        pathname: '/confirm-booking',
      });
    }
  };

  // If the user is not logged in, redirect them to login
  const onBookPublicMoveToLoginPage = () => {
    dispatch(clearCompanyData());
    dispatch(
      redirectPublicUser({
        companyId: authDetails?.companyData?.id,
        companyName: authDetails?.companyData?.name,
        classId: details?.uuid,
        branchDetails: authDetails?.companyData?.branches?.items,
        imageUrl: authDetails?.companyData?.imageUrl,
        showKidsAfterSignup: authDetails?.companyData?.showKidsAfterSignup,
        eventDate: details?.start_branch_time,
        haveKids: details?.haveKids,
        bookingType: details?.isCamp ? 'camp' : 'class',
      })
    );
    history.push('/login');
  };

  // Decide the text for the main button
  const showContinueBtnText = () => {
    let txt = 'Continue Booking';

    const isBookedIsCampNoBooking = details?.isBooked && details?.isCamp;
    if (isBookedIsCampNoBooking) {
      txt = 'View Details';
    } else if (
      details?.isBooked &&
      details.typename !== BOOKING_TYPES.APPOINTMENT &&
      details?.familyMembers?.length === 0
    ) {
      txt = 'Cancel Registration';
    } else if (details?.isBooked && details.typename !== BOOKING_TYPES.APPOINTMENT) {
      txt = 'Update Registration';
    }
    return txt;
  };
  // Convert registration dates to branch timezone for proper comparison and display
  const registrationOpenDate = details?.reg_open_Date
    ? moment.tz(details.reg_open_Date, timezone)
    : moment.tz(details?.createdAt, 'UTC');
  const registrationCloseDate = details?.reg_close_Date
    ? moment.tz(details.reg_close_Date, timezone)
    : moment.tz(details?.start_branch_time, timezone);
  const currentTime = moment.tz(timezone);
  const canContinueBooking =
    canProgressFromMultiDayCampLink(details) ||
    (registrationOpenDate?.isSameOrBefore(currentTime) &&
      registrationCloseDate?.isSameOrAfter(currentTime));
  const modalActionButtonStyle = {
    position: 'static',
    transform: 'none',
    margin: '0',
  };
  const showWaitlistAction =
    details?.status !== 'cancelled' && (isClassFull || details?.isWaitlisted);
  const showBookingAction =
    !isClassFull && (details?.status !== 'cancelled' || isMultiDayCamp) && canContinueBooking;
  const showUpdateRegistrationAction =
    isClassFull && details?.haveKids === true && details?.familyMembers?.length > 0;
  const showModalActions = showWaitlistAction || showBookingAction || showUpdateRegistrationAction;

  console.log(
    'registrationCloseDate',
    registrationCloseDate?.format(),
    details?.reg_close_Date,
    details?.start_branch_time
  );
  return (
    <>
      {/* Existing modal for class details */}
      <Modal
        show={show}
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="class-info-modal"
        style={
          viewportHeight ? {'--class-modal-viewport-height': `${viewportHeight}px`} : undefined
        }
      >
        <div className="modal-content-inner class-details-modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{details?.isCamp ? 'Camp Details' : 'Class Details'}</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={onHide}
            ></button>
          </div>
          <div className="modal-body class-details-modal-body">
            {isClassFull && (
              <div className="class-details-status class-details-status--full" role="status">
                <i className="fas fa-users" aria-hidden="true"></i>
                <span>{details.isCamp ? 'Camp Full' : 'Class Full'}</span>
              </div>
            )}
            {details?.isWaitlisted && (
              <div className="class-details-waitlist-state" role="status">
                <i className="fas fa-check-circle" aria-hidden="true"></i>
                <span>You’re on the wait list</span>
              </div>
            )}
            <div className="classInfoBlock">
              {details?.imageUrl && (
                <figure className="classInfo-img">
                  <img src={IMAGE_URL + details?.imageUrl} alt="" className="img-fluid" />
                </figure>
              )}

              <div className="class-details-summary">
                <p className="service text-dark _name _title-3" style={{fontWeight: '500'}}>
                  <span className="icon-holder-txt">
                    {details?.virtualSession && <i className="fas fa-video"></i>}
                    {details?.isCamp && details?.commonT
                      ? details?.commonT
                      : details?.serviceName}, {details?.branchName}
                  </span>
                </p>

                <div className="desc-normal class-details-description">
                  {details?.isCamp && details?.commonDes
                    ? details?.commonDes
                    : details?.description}
                </div>

                {details?.zoomLink && details?.isBooked && (
                  <div className="zoomLink">
                    <p className="_name _title-3 mr-2">Zoom Link:</p>
                    <span
                      className="iconRound"
                      onClick={() => openInNewTab(details?.zoomLink)}
                      onKeyPress={null}
                      role="link"
                      tabIndex={-1}
                    >
                      <i className="bx bx-video"></i>
                    </span>
                  </div>
                )}
              </div>

              {!details?.onlineBooking &&
                typeof details?.access !== 'undefined' &&
                details?.access === 'private' && (
                  <div className="text-center m-3">
                    <span className="text-danger font-weight-bold">
                      Sorry ! This class is not available for online booking.
                    </span>
                  </div>
                )}
              {details?.status === 'cancelled' && !isMultiDayCamp && (
                <div className="text-center m-3">
                  <span className="text-danger font-weight-bold">
                    Sorry! This class is cancelled.
                  </span>
                </div>
              )}

              <div className="date-time-div class-details-date-time">
                <div className="date-div">
                  <span className="_icon">
                    <img src={calendar} alt="" />
                  </span>
                  {moment(details?.start_branch_time).format('dddd, MMMM Do YYYY')}
                </div>
                <div className="time-div">
                  <span className="_icon">
                    <i className="far fa-clock"></i>
                  </span>
                  {moment(details?.start_branch_time).format('hh:mm A')}
                </div>
              </div>
            </div>

            <div className="cinfo-div-outter class-details-meta">
              <div className="cinfo-div mb-2">
                <span className="cinfo-title">
                  <i className="bx bx-user"></i> Coaches
                </span>
                <span className="cinfo">
                  {details?.selectedTrainers?.map((trainer, index) => (
                    <span key={trainer?.id}>
                      {trainer?.trainerName}
                      {details?.selectedTrainers?.length - 1 !== index && ', '}
                    </span>
                  ))}
                </span>
              </div>
              <div className="cinfo-div mb-2">
                <span className="cinfo-title">
                  <i className="bx bx-user"></i> Booked Members
                </span>
                <span className="cinfo">
                  {details?.familyMembers?.map((member, index) => (
                    <span key={`${member?.orderId}-${index}`}>
                      {member?.isParent
                        ? authDetails?.companyData?.member?.name
                        : `${member?.firstName} ${member?.lastName}`}
                      {details?.familyMembers?.length - 1 !== index && ', '}
                    </span>
                  ))}
                </span>
              </div>

              {/* {memberService !== null &&
                membership_pack == null &&
                authDetails?.authDetails &&
                !groupClassDetail[0]?.campDaysBookTogether &&
                !groupClassDetail[0]?.isCamp && (
                  <div className="cinfo-div">
                    <span className="cinfo-title">
                      <i className="bx bx-money"></i>Credits Remaining for22 {details?.serviceName}:{' '}
                    </span>
                    <span className="cinfo">{loading ? 'Loading.....' : remainingCredits}</span>
                  </div>
                )}
              {membership_pack != null && (
                <div className="cinfo-div">
                  <span className="cinfo-title">
                    <i className="bx bx-money"></i>Credits Remaining for {details?.serviceName}:{' '}
                  </span>
                  <span className="cinfo">
                    {loading === true && 'Loading.....'}
                    {isUnlimited === true && loading !== true && 'Unlimited membership pack active'}
                    {isUnlimited !== true && loading !== true && remainingCredits}
                  </span>
                </div>
              )} */}
              <div className="class-details-registration">
                {!isMultiDayCamp &&
                  registrationOpenDate &&
                  !registrationOpenDate?.isSameOrBefore(currentTime) && (
                    <p className="class-details-registration__message _text-theme">
                      Registration Opens:{' '}
                      <span>{registrationOpenDate?.format('dddd, MMMM D, YYYY h:mm a z')}</span>
                    </p>
                  )}
                {!isMultiDayCamp && registrationCloseDate?.isSameOrAfter(currentTime) && (
                  <p className="class-details-registration__message">
                    Registration Closes:{' '}
                    <span>{registrationCloseDate?.format('dddd, MMMM D, YYYY h:mm a z')}</span>
                  </p>
                )}
                {/* //! Show "Registration now closed" if current time is after reg_close_Date */}
                {!isMultiDayCamp && currentTime.isAfter(registrationCloseDate) && (
                  <p className="class-details-registration__message _text-theme">
                    Registration now closed
                  </p>
                )}
                {isMultiDayCamp && linkedOccurrenceUnavailable && (
                  <p className="class-details-registration__message _text-theme">
                    Registration is closed for this camp day (
                    {moment(details?.start_branch_time).format('MMMM Do, YYYY')}).
                  </p>
                )}
                {isMultiDayCamp && multiDayCampAvailability?.days?.length > 0 && (
                  <p className="class-details-registration__message">
                    Camp days available to book:{' '}
                    <span>
                      {moment(multiDayCampAvailability.startsAt).format('MMMM Do, YYYY hh:mm A')} -{' '}
                      {moment(multiDayCampAvailability.endsAt).format('MMMM Do, YYYY hh:mm A')}
                    </span>
                  </p>
                )}
                {isMultiDayCamp && multiDayCampAvailability?.days?.length === 0 && (
                  <p className="class-details-registration__message _text-theme">
                    There are no camp days currently available to book.
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* Action Button Section */}
          {showModalActions && (
            <div className="class-details-actions">
              {showWaitlistAction && <WaitlistActions details={details} isFull={isClassFull} />}
              {showBookingAction &&
                (authDetails.authDetails ? (
                  <button className="btn _btnRound" onClick={onBook} style={modalActionButtonStyle}>
                    {showContinueBtnText()}
                  </button>
                ) : (
                  <button
                    className="btn _btnRound"
                    onClick={onBookPublicMoveToLoginPage}
                    style={{
                      ...modalActionButtonStyle,
                      backgroundColor: '#c82638',
                      color: 'white',
                    }}
                  >
                    Continue Booking
                  </button>
                ))}
              {showUpdateRegistrationAction && (
                <button className="btn _btnRound" onClick={onBook} style={modalActionButtonStyle}>
                  Update Registration
                </button>
              )}
            </div>
          )}
        </div>

        {cancelClassLoading && (
          <div className="overlay">
            <div className="spinner"></div>
          </div>
        )}
      </Modal>

      {/* NEW: "Are you sure you want to cancel?" Modal */}
      <Modal show={showCancelConfirmModal} onHide={() => setShowCancelConfirmModal(false)} centered>
        <div className="modal-header">
          <h5 className="modal-title">Cancel Class</h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setShowCancelConfirmModal(false)}
          ></button>
        </div>
        <div className="modal-body">
          <p>Are you sure you want to cancel your class?</p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setShowCancelConfirmModal(false)}
          >
            No
          </button>
          <button type="button" className="btn btn-danger" onClick={cancelClass}>
            Yes, Cancel
          </button>
        </div>
      </Modal>

      <ToastNotification />
    </>
  );
};

export default EventsClassModal;
